import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { ReactElement } from 'react';
import TypographyLevel from 'shared/components/Typography';

/**
 * Component for adding a new client in the Manage Clients page.
 * @param {MCActionProps} props - The component props.
 * @returns {ReactElement} React element representing the Add Client component.
 */
const MCAction = ({
    setStatusPage,
    statusPage,
    statusClient,
}: MCActionProps): ReactElement => {
    const theme = useTheme();
    const match = useMediaQuery(theme.breakpoints.up('md'));
    return (
        <Grid className="header-manage-client" container columnSpacing={0}>
            {!match && (
                <Grid
                    xs={1}
                    item
                    className="button-left-back"
                    onClick={() => setStatusPage('view')}
                >
                    <Box>
                        <img
                            src="/images/icons/ARHeader.svg"
                            height={10}
                            width={10}
                            alt="Back to client list"
                        />
                    </Box>
                </Grid>
            )}
            <Grid
                xs={11}
                md={10}
                item
                className="breadcrumb"
                role="navigation"
                aria-label="breadcrumb adding checklist"
            >
                <Grid container>
                    <Grid item>
                        <TypographyLevel variant="two">
                            Manage Checklists
                        </TypographyLevel>
                    </Grid>
                    <Grid item>
                        <Box>
                            <ArrowForwardIosRoundedIcon className="arrow" />
                        </Box>
                    </Grid>
                    <Grid item>
                        <TypographyLevel variant="two">
                            {statusPage === 'add'
                                ? ' Add new Checklists'
                                : statusClient}
                        </TypographyLevel>
                    </Grid>
                </Grid>
            </Grid>
            {match && (
                <Grid
                    xs={2}
                    item
                    className="closeButton"
                    onClick={() => setStatusPage('view')}
                >
                    {' '}
                    <Box>
                        <img
                            src="/images/icons/CloseX.svg"
                            height={20}
                            width={20}
                            alt="close client detail"
                        />
                    </Box>
                </Grid>
            )}
        </Grid>
    );
};

export default MCAction;
